import * as React from 'react'
import { FormattedNumber } from 'react-intl'
import { useBookingFormStore } from '../providers/BookingFormStoreProvider'

type FormattedPriceProps = {
  // Decimal places to show. Default 0 = whole currency units (calendar, price bars).
  // The price breakdown (steps 3 & 4) passes 2 so the cent-precise discount lines add up
  // exactly against Grundpreis and Gesamt.
  fractionDigits?: number
  value: number
}

const FormattedPrice: React.FunctionComponent<FormattedPriceProps> = ({
  fractionDigits = 0,
  value,
}) => {
  const currency = useBookingFormStore((state) => state.currency)

  return (
    <FormattedNumber
      currency={currency}
      maximumFractionDigits={fractionDigits}
      minimumFractionDigits={fractionDigits}
      style="currency"
      value={value}
    />
  )
}

export default FormattedPrice
